module.exports = __webpack_public_path__ + "media/images/pillar_pr-43cc8138765519c8a454d05edb6d0c79.jpg";